import React, { Component } from 'react';
import Text, { TEXT } from 'src/view/components/Text/Text';

export default class OopsScreen extends Component<{}, {}> {
  render() {
    return (
      <div className="d-flex flex-column full-width flex-1 align-items-center justify-content-center">
        <Text type={TEXT.CUSTOM} text="error_try_again" className="family-semibold text-size-42" />
        <Text type={TEXT.CUSTOM} text="possible_you_dont_have_permissions_or_page_not_found" className="text-size-24 mt-6" />
      </div>
    );
  }
}
